import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgTimeNeverGlyphSecondary from './svgs/TimeNeverGlyphSecondary.js';
import SvgTimeNeverGlyph from './svgs/TimeNeverGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var timeNeverGlyph = (props => useIcon(SvgTimeNeverGlyph, SvgTimeNeverGlyphSecondary, props));

export { timeNeverGlyph as default };
